module.exports = __webpack_public_path__ + "static/img/1014_small.fe80cf4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1014_small.png
// module id = 9JH5
// module chunks = 1